export enum ErrorIgnoredMessagesEnum {
    ALLOCATION_NOT_ENOUGH_LIQUIDITY = "The liquidity of the portfolio cannot be inferior to 0",
}
